import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Retry } from '@services/decorators/retry.decorator'
import { HttpClient } from '@angular/common/http'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	SupplierEnrollmentNoticeFeasibility,
	SupplierEnrollmentNoticeFeasibilityRequest,
	SupplierEnrollmentNoticeFeasibilitySearch, SupplierEnrollmentNoticeFeasibilityAnswerRequest
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-feasibility.model'
import { BaseResponse } from '@services/api/api-base.service'

@Injectable({
	providedIn: 'root'
})
export class SupplierEnrollmentNoticeFeasibilityService extends ManagementApiBaseService<SupplierEnrollmentNoticeFeasibilitySearch> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.sortColumn = 'createdAt'
		this.source = 'supplier-enrollment-notice-feasibility-proposals'
		this.searchTerm = new SupplierEnrollmentNoticeFeasibilitySearch()
	}

	save(request: SupplierEnrollmentNoticeFeasibilityRequest) {
		return this.post<SupplierEnrollmentNoticeFeasibilityRequest, SupplierEnrollmentNoticeFeasibility>(`${this.source}`, request).pipe(
			map(response => new BaseResponse({ id: response.id }))
		)
	}

	latest(sessionId: string, enrollmentId: string) {
		return this.get<SupplierEnrollmentNoticeFeasibility>(`${this.source}/latest/${sessionId}/${enrollmentId}`).pipe(
			map(response => new SupplierEnrollmentNoticeFeasibility(response))
		)
	}

	listable(sessionId: string, enrollmentId: string) {
		return this.get<Array<SupplierEnrollmentNoticeFeasibility>>(`${this.source}/${sessionId}/${enrollmentId}`).pipe(
			map(response => response.map(it => new SupplierEnrollmentNoticeFeasibility(it)))
		)
	}

	@Retry(3)
	opened(id: string, description?: string) {
		return this.patch<any>(`${this.source}/opened`, { id, description })
	}

	@Retry(3)
	closed(id: string, description?: string) {
		return this.patch<any>(`${this.source}/closed`, { id, description })
	}

	@Retry(3)
	answer(request: SupplierEnrollmentNoticeFeasibilityAnswerRequest) {
		return this.patch<any>(`${this.source}/answers`, request)
	}
}
